export const USER_ADMIN_URL = `${window.location.origin}/admin/`;

export const INSPECTION_OVERDUE_DAYS = 365;

export const PDF_EXTENSION = '.pdf';
